import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { AbstractDataServiceV2 } from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import { CustomizeHttpUrlGenerator } from 'src/app/store/core/url/customizeHttpUrlGenerator';
import { ProviderServiceOptionModel } from '../../../api/entity/providerServiceOption.model';
import { ProviderServiceOptionConverter } from '../../../api/entity/converter/providerServiceOption.converter';

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceOptionDataService extends AbstractDataServiceV2<ProviderServiceOptionModel, ProviderServiceOptionConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: ProviderServiceOptionConverter
    ) {
        super('ProviderServiceOption', http, httpUrlGenerator, logger, config, converter);
    }
}

